// reusable check for if the updateFunction and field were both passed, if so, then use the updateFunction
const safeUpdateFunction = (e, val, updateFunction, field, metaDataField) => {
    if(field === "categories"){
        console.log(field, val);
    }
    const newField = metaDataField || field || "";
    if(updateFunction && newField){
        updateFunction(e, newField, val);
    }
    else if(updateFunction && !newField) {        
        updateFunction(e, null, val);
    }
}

export default safeUpdateFunction